export enum FavoriteType {
  Report = "report",
  Profile = "profile",
  Competition = "competition",
}
